import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import {PagerService} from '../../shared/services/pager.service';

@Component({
  selector: 'biz-previous-processes-table',
  templateUrl: './previous-processes-table.component.html',
  styleUrls: ['./previous-processes-table.component.scss']
})
export class PreviousProcessesTableComponent {
  @Input() history: Array<any> = [];
  @Input() isLoading: boolean;
  @Input() isDownloading = true;
  @Input() isProcessing = false;
  @Output() onDownloadFile = new EventEmitter<any>();
  @Output() onViewSummary = new EventEmitter<any>();
  public pageSize = 10;
  public currentPage: number;
  public historyPaginated: Array<any> = [];
  constructor(private _pagerService: PagerService, private ref: ChangeDetectorRef) { }

  ngOnChanges() {
    if (this.history) {
      const begin = !this.currentPage ? 0 : this.currentPage;
      const end = begin ? begin+1 : 1;
      this.historyPaginated = this.history.slice(this.pageSize*begin, this.pageSize*end);
      this.ref.detectChanges();
    }
  }

  onPaginationEvent(event) {
    this.pageSize = event.pageSize;
    const pager = this._pagerService.getPager(this.history.length, event.pageIndex + 1, this.pageSize);
    this.historyPaginated = this.history.slice(pager.startIndex, pager.endIndex + 1);
    this.currentPage = event.pageIndex;
  }

  viewSummary(history) {
    if (history.DescriptionStateBEX === 'Done' && history.ImportPackageIntegrity) {
      this.onViewSummary.emit(history);
    }
  }

  downloadFile(history) {
    if (history.DescriptionStateBEX === 'Done' && history.ImportPackageIntegrity){
      this.onDownloadFile.emit(history);
    }
  }

}
